import React from 'react';
import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { Intl } from '@atlassian/jira-shared-types/src/general.tsx';
import type { Holidays } from '../../../../common/types';
import { Column, Row, Header } from '../../../../common/ui/styled';
import { sortHolidays } from '../../../../common/utils/calendars/utils';
import { HolidayView } from './main';
import messages from './messages';

type HolidayViewProps = {
	holidays: Holidays;
} & Intl;

const Holiday = ({ intl: { formatMessage }, holidays }: HolidayViewProps) => {
	if (!holidays.length) {
		return null;
	}

	const sortedHolidays = sortHolidays(holidays);

	return (
		<>
			<HolidayHeader>
				{/* eslint-disable-next-line @atlaskit/design-system/use-heading */}
				<h2> {formatMessage(messages.holidaysHeader)} </h2>
			</HolidayHeader>
			<HolidaysGrid>
				<Row>
					<Column>
						<b>{formatMessage(messages.name)}</b>
					</Column>
					<Column>
						<b>{formatMessage(messages.date)}</b>
					</Column>
					<Column>
						<b>{formatMessage(messages.frequency)}</b>
					</Column>
				</Row>
			</HolidaysGrid>
			<HolidaysGrid>
				{sortedHolidays.map((holiday, index) => (
					<HolidayView key={index} holiday={holiday} />
				))}
			</HolidaysGrid>
		</>
	);
};

export const HolidaysView = injectIntl(Holiday);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const HolidaysGrid = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text', colors.DN0),
	marginTop: token('space.100', '8px'),
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const HolidayHeader: React.ComponentType<any> = styled(Header)({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	borderBottom: `2px solid ${token('color.border', colors.N40)}`,
	paddingBottom: token('space.100', '8px'),
});
